import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import "../UnitAdmin/formProgress.scss";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { formProgress } from "../../../store/atoms";
import { useNavigate } from "react-router-dom"; // Using useNavigate for redirection
import {
  auditSwitchType,
  protocolType,
  switchProtocolType,
} from "../../../store/audit details/atom";

const urlParams = new URLSearchParams(window.location.search);
const auditNumber = urlParams.get("auditNumber"); // Assuming 'auditNumber' is the query parameter

const steps = [
  { stepNumber: 0, stepName: "Unit Details" },
  {
    stepNumber: 1,
    stepName: "Audit Details",
  },
  {
    stepNumber: 2,
    stepName: "Protocol Details",
    redirectedUrl: `?auditNumber=${auditNumber}`,
  },
  {
    stepNumber: 3,
    stepName: "Scoring Details",
    redirectedUrl: `?auditNumber=${auditNumber}`,
  },
  {
    stepNumber: 4,
    stepName: "Tech Review",
    redirectedUrl: `?auditNumber=${auditNumber}`,
  },
];

export default function FormProgress() {
  const [progressValue, setProgressValue] = useRecoilState(formProgress); // Recoil state for progress
  const navigate = useNavigate(); // Using useNavigate for redirection
  const setSwitchValue = useSetRecoilState(auditSwitchType);
  const getStoredProtocol = useRecoilValue(switchProtocolType);
  const setProtocolType = useSetRecoilState(protocolType);
  const handleStepClick = (step) => {
    // alert("working");
    // Allow clicking on the current or previous steps only
    if (step.stepNumber < progressValue && step.redirectedUrl) {
      setSwitchValue("change");
      // setProgressValue(step.stepNumber); // Update the Recoil state with the clicked step
      if (step.redirectedUrl) {
        if (getStoredProtocol) {
          setProtocolType(getStoredProtocol);
        }
        navigate(step.redirectedUrl); // Redirect to the specified URL
      }
    }
  };

  return (
    <Box id="formProgress">
      <Stepper activeStep={progressValue} alternativeLabel>
        {steps.map((step) => (
          <Step key={step.stepNumber}>
            <StepLabel
            // onClick={() => handleStepClick(step)}
            // Disable clicking on future steps
            // style={{
            //   cursor:
            // step.stepNumber <= progressValue ? "pointer" : "not-allowed",
            // }}
            >
              {step.stepName}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
